import React, { useEffect, useState } from "react";
import { initFacebookPixel } from '../facebookPixel'


const GA_MEASUREMENT_ID = 'GTM-W6JBM9K7';
// const FACEBOOK_PIXEL_ID = '1266850888742347'; // Prime Circle
const FACEBOOK_PIXEL_ID2 = '1066224985837618';  // James BM

const loadTrackingScripts = () => {
  // Prevent duplicate loading
  if (window.trackingScriptsLoaded) return;
  window.trackingScriptsLoaded = true;


  // Load Google Analytics
  const gaScript = document.createElement("script");
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  gaScript.async = true;
  document.head.appendChild(gaScript);

  gaScript.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_MEASUREMENT_ID);
  };

  // Init Facebook Pixel
  // initFacebookPixel(FACEBOOK_PIXEL_ID);
  initFacebookPixel(FACEBOOK_PIXEL_ID2);
};

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    // Default to opt-in (scripts load unless opted out)
    if (consent === "declined") {
      // Do nothing
    } else {
      loadTrackingScripts(); // Fire by default
    }

    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
    loadTrackingScripts();
  };

  const handleDecline = () => {
    localStorage.setItem("cookieConsent", "declined");
    setShowBanner(false);
    window.location.reload(); // Reload to prevent scripts firing again
  };




  if (!showBanner) return null;
  return (
    <div className="fixed bottom-0 md:left-2 md:bottom-2 w-full md:rounded-lg mx-auto md:mx-0 md:max-w-xl bg-gray-50 text-gray-800 p-4 shadow-lg" style={{ zIndex: 1000 }}>
      <div className="max-w-5xl mx-auto flex flex-col items-start justify-between space-y-3">
        <p className="text-xs md:text-base">
          We use essential and non-essential cookies to improve user experience and analyze website traffic.
          By continuing, you accept. You may opt out at any time. See our <a href="/privacy-policy" className="underline" target="_blank">Privacy Policy</a> for more information.
        </p>
        <div className="flex space-x-2">
          <button
            onClick={handleAccept}
            className="text-xs bg-white hover:bg-gray-700 text-gray-700 border border-gray-700 hover:text-white px-4 py-2 rounded-lg transition"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="text-xs bg-gray-700 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition"
          >
            Opt Out
          </button>
        </div>
      </div>
    </div>
  );
};

